import { Table as BootstrapTable } from 'react-bootstrap';

import React from 'react';

import moment from "moment";
import sort from "array-sort";

const Table = ({ domain, data }) => {
    const [ state, setState ] = React.useState({
        data: [],
        sorting: {
            order: null,
            field: null,
        }
    });

    React.useEffect(() => {
        if (data.length) setState({ ...state, data, sorting: { order: null, field: null } });
    }, [ data ]);

    React.useEffect(() => {
        if (!state.sorting.order && !state.sorting.field) return;

        const sorted = sort(state.data, state.sorting.field, { reverse: state.sorting.order === 'desc' });

        setState({ ...state, data: sorted });
    }, [ state.sorting.order, state.sorting.field ]);

    const on_sort = (field) => {
        const sorting = state.sorting;

        if (sorting.field === field) {
            sorting.order = sorting.order === 'asc' ? 'desc' : 'asc';
        } else {
            sorting.order = 'asc';
            sorting.field = field;
        }

        return setState({ ...state, sorting });
    };

    const format_antivirus_results = (service, results = []) => {
        if (service === 'virustotal') return results.map((result) => result.description && <p><b>{result.request} -</b> {result.description}</p>);

        return results.map((result) => result.description);
    }

    return (
        <BootstrapTable bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead style={{ background: 'whitesmoke' }}>
                <tr>
                    <th onClick={() => on_sort('checked_at')}>Checked At</th>
                    <th onClick={() => on_sort('flagged')}>Flagged</th>
                    <th onClick={() => on_sort('antiviruses.virustotal')}>Virus Total</th>
                    <th onClick={() => on_sort('antiviruses.sucuri')}>Sucuri</th>
                    <th onClick={() => on_sort('antiviruses.avast')}>Avast</th>
                    <th onClick={() => on_sort('antiviruses.google')}>Google</th>
                    <th onClick={() => on_sort('antiviruses.google')}>Origin</th>
                </tr>
            </thead>

            <tbody>
                {
                    state.data.map((row) => {
                        return (
                            <tr>
                                <td>{row.created_at ? moment.unix(row.created_at).utc().format(`YYYY-MM-DD HH:mm`) : ""}</td>
                                <td>{row.flagged}</td>
                                <td>{format_antivirus_results("virustotal", row.antiviruses.virustotal)}</td>
                                <td>{format_antivirus_results("sucuri", row.antiviruses.sucuri)}</td>
                                <td>{format_antivirus_results("avast", row.antiviruses.avast)}</td>
                                <td>{format_antivirus_results("google", row.antiviruses.google)}</td>
                                <td>{row.origin}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </BootstrapTable>
    )
};

export default Table;



// WEBPACK FOOTER //
// ./src/scenes/DomainsV2/components/History/components/Table/index.js